import iconfont from "@/components/iconfont.vue";
import scanCode from "@/components/scanCode.vue";
import iconBtn from "@/components/iconBtn.vue";
import popoverButton from "@/components/popoverButton.vue";
import SvgIcon from "@/components/SvgIcon.vue";
import LocalSvgIcon from "@/components/LocalSvgIcon.vue";
import paginationVue from "@/components/paginationVue.vue";
import videoPlayer from "@/components/videoPlayer.vue";
import inputTypingComp from "@/components/inputTypingComp.vue";
import McTable from "@/components/McTableComp/table.vue";
import McTableCol from "@/components/McTableComp/col.vue";
import Footer from "@/views/Layout/common/Footer.vue";
import ButtonAICompHandler from "@/components/ButtonAICompHandler.vue";
import HeaderCrumbs from "@/components/HeaderCrumbs.vue";

/**
 * 全局组件
 */
const GlobalComponents = {
  install(Vue) {
    Vue.component("iconfont", iconfont);
    Vue.component("scanCode", scanCode);
    Vue.component("iconBtn", iconBtn);
    Vue.component("popoverButton", popoverButton);
    Vue.component("SvgIcon", SvgIcon);
    Vue.component("LocalSvgIcon", LocalSvgIcon); // 本地 SVG 文件图标组件，使用 name 读取 assets/icon/icons.js 映射
    Vue.component("paginationVue", paginationVue);
    Vue.component("videoPlayer", videoPlayer);
    Vue.component("inputTypingComp", inputTypingComp);
    Vue.component("Footer", Footer);
    Vue.component("McTable", McTable);
    Vue.component("McTableCol", McTableCol);
    Vue.component("ButtonAICompHandler", ButtonAICompHandler);
    Vue.component("HeaderCrumbs", HeaderCrumbs);
  }
};
export default GlobalComponents;